export const chartExtend = {
  series: {
    itemStyle: {
      normal: {
        color: '#fd9b21',
      },
    },
  },
  yAxis: {
    splitLine: {
      lineStyle: {
        color: '#DADEE3',
        width: 0.2,
      },
    },
  },
  xAxis: {
    splitLine: {
      lineStyle: {
        color: '#DADEE3',
        width: 0.2,
      },
    },
    axisLine: {
      show: true,
      lineStyle: {
        color: '#fd9b21',
        width: 2,
      },
    },
    axisLabel: {
      textStyle: {
        color: '#262626',
        align: 'center',
      },
    },
    axisTick: {
      alignWithLabel: true,
    },
  },
};
